export default __webpack_public_path__ + "static/media/lateral_b.fff12c9b.jpg";